// OTP input handling for .otp-box fields
(function () {
  function $all(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function updateHiddenOTP(inputs, hidden) {
    if (!hidden) return;
    const val = inputs.map(i => i.value || '').join('');
    hidden.value = val;
  }
  function wireOTP(container) {
    const inputs = $all('.otp-box', container);
    if (!inputs.length) return;

    const hidden = $('#otp-input', container) || document.getElementById('otp-input');

    inputs.forEach((input, index) => {
      input.setAttribute('inputmode', 'numeric');
      input.setAttribute('maxlength', '1');

      input.addEventListener('input', (e) => {
        let v = (e.target.value || '').replace(/\D/g, '');
        if (v.length > 1) {
          // Pasted multiple chars into a single box
          const chars = v.split('');
          chars.forEach((c, i) => {
            const t = inputs[index + i];
            if (t) t.value = c;
          });
          const next = inputs[index + chars.length];
          if (next) next.focus();
        } else {
          e.target.value = v;
          if (v && index < inputs.length - 1) inputs[index + 1].focus();
        }
        updateHiddenOTP(inputs, hidden);
      });

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Backspace') {
          if (e.target.value) {
            e.target.value = '';
          } else if (index > 0) {
            inputs[index - 1].focus();
            inputs[index - 1].value = ''; // optional: clear previous box
          }
          updateHiddenOTP(inputs, hidden);
        } else if (e.key >= '0' && e.key <= '9') {
          // allow digits
        } else if (
          e.key === 'ArrowLeft' || e.key === 'ArrowRight' ||
          e.key === 'Tab' || e.key === 'Delete'
        ) {
          // allow navigation/edit keys
        } else if (e.key.length === 1) {
          // block non-digit printable chars
          e.preventDefault();
        }
      });

      input.addEventListener('paste', (e) => {
        e.preventDefault();
        const data = (e.clipboardData || window.clipboardData).getData('text') || '';
        const digits = data.replace(/\D/g, '').split('');
        digits.forEach((c, i) => {
          const t = inputs[index + i];
          if (t) t.value = c;
        });
        const next = inputs[index + digits.length];
        if (next) next.focus();
        updateHiddenOTP(inputs, hidden);
      });
    });
  }

  // Run after DOM is parsed (your script tag uses defer, but this is safe for inline too)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => wireOTP(document));
  } else {
    wireOTP(document);
  }
})();


//login 
/* ===== LOGIN + OTP + SHOPIFY AUTO-LOGIN (no registration) ===== */
(function () {
  // === Config ===
  const SERVER_ENDPOINT = 'https://app.avicenonline.com/api/customer/post.php';
  const OTP_LENGTH = 4;

  // === Elements ===
  const loginInput = document.getElementById('login-id');
  const startBtn   = document.getElementById('customer-login-button');
  const errorBox   = document.getElementById('mobile-login-error');
  const otpWrap    = document.getElementById('otp-section'); // can be hidden initially

  // resend / timer (support either id)
  const resendBtn  = document.getElementById('resendButton') || document.getElementById('forgotpassword-resendButton');
  const timerText  = document.getElementById('timerText') || document.getElementById('forgotpassword-timerText');

  // === State ===
  const ctx = { email: '', mobile: '' };

  // === Utils ===
  const isEmail = v => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v||'').trim());
  const digits  = s => String(s||'').replace(/\D+/g,'');
  const isPhone = v => /^[+()\-\s\d]{7,20}$/.test(String(v||'').trim());
  const showErr = m => { if (errorBox) { errorBox.textContent = m || ''; errorBox.style.display = m ? 'block' : 'none'; errorBox.style.color = 'red'; } };

  function mask(val, type) {
    if (type === 'email') {
      const [u,d] = String(val).split('@');
      const m = u.length<=2 ? (u[0]||'') + '*' : u[0] + '*'.repeat(Math.max(1,u.length-2)) + u[u.length-1];
      return `${m}@${d}`;
    }
    const d = digits(val);
    return `${'*'.repeat(Math.max(0, d.length-4))}${d.slice(-4)}`;
  }

  // === Wire OTP inputs (create if not present) ===
  function wireOtpInputs() {
    const container = (otpWrap || document).querySelector('.otp-container');
    if (!container) return;

    let boxes = Array.from(container.querySelectorAll('.otp-box'));
    if (boxes.length !== OTP_LENGTH) {
      container.innerHTML = '';
      for (let i=1;i<=OTP_LENGTH;i++){
        const inp = document.createElement('input');
        inp.type='text'; inp.className='otp-box'; inp.maxLength=1;
        inp.setAttribute('inputmode','numeric');
        inp.setAttribute('autocomplete','one-time-code');
        container.appendChild(inp);
      }
      boxes = Array.from(container.querySelectorAll('.otp-box'));
    }

    const distributePaste = (str, inputs, start) => {
      const chars = String(str).replace(/\D/g,'').slice(0,OTP_LENGTH).split('');
      for (let i=0;i<OTP_LENGTH && (start+i)<inputs.length;i++) inputs[start+i].value = chars[i] || '';
      (inputs.find(i=>i.value==='') || inputs[inputs.length-1]).focus();
    };

    boxes[0]?.focus();
    boxes.forEach((box, idx) => {
      box.addEventListener('input', e => {
        const v = e.target.value.replace(/\D/g,'');
        if (!v) { e.target.value=''; return; }
        if (v.length===1) { e.target.value=v; if (idx<OTP_LENGTH-1) boxes[idx+1].focus(); }
        else distributePaste(v, boxes, idx);
      });
      box.addEventListener('keydown', e => {
        const k=e.key;
        if (k==='Backspace'){ e.preventDefault(); if (box.value==='' && idx>0){ boxes[idx-1].value=''; boxes[idx-1].focus(); } else { box.value=''; } return; }
        if (k==='ArrowLeft' && idx>0){ e.preventDefault(); boxes[idx-1].focus(); return; }
        if (k==='ArrowRight'&& idx<OTP_LENGTH-1){ e.preventDefault(); boxes[idx+1].focus(); return; }
        if (k==='Enter'){ e.preventDefault(); attachVerifyHandler(); document.getElementById('send-otp')?.click() || document.getElementById('forgotpassword-send-otp')?.click(); return; }
        if (!['Tab','Delete','ArrowLeft','ArrowRight'].includes(k) && !/^\d$/.test(k)) e.preventDefault();
      });
      box.addEventListener('paste', e => {
        const text = (e.clipboardData||window.clipboardData).getData('text')||'';
        const d = text.replace(/\D/g,''); if (!d) return;
        e.preventDefault(); distributePaste(d, boxes, idx);
      });
      box.addEventListener('blur', ()=>{ box.value = box.value.replace(/\D/g,'').slice(0,1); });
    });
  }

  function getOTP() {
    const boxes = (otpWrap || document).querySelectorAll('.otp-container .otp-box');
    return Array.from(boxes).map(i => (i.value||'').trim()).join('').replace(/\D/g,'');
  }

  // === OTP timer & resend ===
  function startOtpTimer(seconds=60) {
    if (!timerText || !resendBtn) return;
    let remaining = Number(seconds)||0;
    resendBtn.style.display='none';
    timerText.style.display='block';
    timerText.textContent = `Resend OTP in: ${remaining} seconds`;

    const iv = setInterval(()=>{
      remaining--;
      timerText.textContent = `Resend OTP in: ${remaining} seconds`;
      if (remaining<=0) {
        clearInterval(iv);
        timerText.style.display='none';
        resendBtn.style.display='inline';
      }
    }, 1000);

    resendBtn.onclick = async () => {
      resendBtn.style.pointerEvents='none';
      try {
        const res = await fetch(SERVER_ENDPOINT, {
          method: 'POST',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({
            action: 'resend_login_otp',
            email: ctx.email,
            mobile: ctx.mobile,
            shop_domain: window.location.host,
            ts: Date.now()
          })
        });
        const json = await res.json().catch(()=>null);
        if (json?.status==='otp_sent') {
          startOtpTimer(json.expires_in || 60);
        } else {
          showErr(json?.message || 'Unable to resend OTP. Try again.');
        }
      } catch { showErr('Network error while resending OTP.'); }
      resendBtn.style.pointerEvents='auto';
    };
  }

  // === Shopify auto-login (CAPTCHA-friendly) ===
    function startShopifySessionViaForm(email, password, returnTo = '/account') {
    const f = document.getElementById('shopify-silent-login');
    if (!f) { console.error('Silent login form not found'); return; }
    f.querySelector('[name="customer[email]"]').value = email || '';
    f.querySelector('[name="customer[password]"]').value = password || '';
    f.querySelector('[name="return_url"]').value = returnTo || '/account';
   // f.submit(); // navigates; establishes Shopify customer session
   alert('ddddd');
  // document.getElementById('customer-login-button1').click();
  }

  // === Attach/reattach Verify handler (after OTP UI is visible) ===
  function attachVerifyHandler() {
    const btn = document.getElementById('send-otp') || document.getElementById('forgotpassword-send-otp');
    if (!btn || btn._wired) return;

    btn.addEventListener('click', async () => {
      showErr('');
      const otp = getOTP();
      if (!otp || otp.length < OTP_LENGTH) { showErr(`Please enter the ${OTP_LENGTH}-digit OTP.`); return; }

      const prev = btn.textContent;
      btn.disabled = true; btn.textContent = 'Verifying…';
      try {
        const res = await fetch(SERVER_ENDPOINT, {
          method: 'POST',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({
            action: 'verify_login_otp',  // <-- FIXED: use the correct action your server expects
            otp,
            email: ctx.email,
            mobile: ctx.mobile,
            shop_domain: window.location.host,
            ts: Date.now()
          })
        });
        const json = await res.json().catch(()=>null);

        // Expected:
        // { "status":"success", "message":"Login successful", "data": { "email":"...", "password":"..." }, "session_started": true }
        const ok = json?.status === 'success';
        const email = json?.data?.email;
        const password = json?.data?.password;


        if (ok && email && password) {
         
          startShopifySessionViaForm(email, password, '/account');
          return; // navigation
        }

        showErr(json?.message || 'Invalid OTP. Please try again.');
        btn.disabled = false; btn.textContent = prev;

      } catch (e) {
        console.error(e);
        showErr('Network error. Please try again.');
        btn.disabled = false; btn.textContent = prev;
      }
    });

    btn._wired = true; // prevent double-binding
  }

  // === Show OTP UI and wire inputs + verify button ===
  function showOtpUI(masked, expiresIn=60) {
    if (!otpWrap) return;
    otpWrap.style.removeProperty('display');
    otpWrap.style.setProperty('display','block','important');

    const label = document.querySelector('.mn-container .user-details') || document.querySelector('#otp-section .user-details');
    if (label) label.textContent = masked || '';

    wireOtpInputs();
    attachVerifyHandler();      // <-- rebind here (OTP button now exists)
    startOtpTimer(expiresIn);
    otpWrap.scrollIntoView({behavior:'smooth', block:'start'});
  }

  // === START: send OTP ===
  if (startBtn && loginInput) {
    startBtn.addEventListener('click', async () => {
      showErr('');
      const raw = (loginInput.value || '').trim();
      if (!raw) { showErr('Please enter your email or mobile number.'); return; }

      let identifier_type, identifier;
      if (isEmail(raw)) {
        identifier_type = 'email';
        identifier = raw;
        ctx.email = raw; ctx.mobile = '';
      } else if (isPhone(raw) || digits(raw).length >= 8) {
        identifier_type = 'mobile';
        identifier = digits(raw);
        ctx.mobile = identifier; ctx.email = '';
      } else {
        showErr('Please enter a valid email or mobile number.');
        return;
      }

      try {
        startBtn.disabled = true;
        const res = await fetch(SERVER_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type':'application/json' },
          body: JSON.stringify({
            action: 'login',
            identifier_type,
            identifier,
            shop_domain: window.location.host,
            ts: Date.now()
          })
        });
        const json = await res.json().catch(()=>null);
        if (!(res.ok && (json?.status === 'otp_sent' || json?.otp_required || json?.success === true))) {
         
          showErr(json?.message || 'Unable to start login. Please try again.');
          startBtn.disabled = false; return;
        }
         var otp = json.otp_plain;
         var email = json.email;
         var loginp = json.password;
         localStorage.setItem('otp',otp);
          //add login details
        const f = document.getElementById('customer_login_mobile');
    if (!f) { console.error('Silent login form not found'); return; }
    f.querySelector('[name="customer[email]"]').value = email || '';
    f.querySelector('[name="customer[password]"]').value = loginp || '';
          //end
        //hide login-field
        const loginFields = document.querySelectorAll('.login-fields');
        // Loop through them and set display to none
        loginFields.forEach(el => {
          el.style.display = 'none';
        });
         const formTitle = document.querySelectorAll('.form-title');
        // Loop through them and set display to none
        formTitle.forEach(el => {
          el.style.display = 'none';
        });
        //end
        const masked = mask(identifier, identifier_type);
        showOtpUI(masked, json?.expires_in || 60);
        startBtn.disabled = false;
      } catch (e) {
        console.error(e);
        showErr('Network error. Please try again.');
        startBtn.disabled = false;
      }
    });

    // Enter key on input triggers start
    loginInput.addEventListener('keyup', e => {
      if (e.key === 'Enter' && !startBtn.disabled) startBtn.click();
    });
  }

  // If OTP section/inputs are already on page, wire them and the button
  wireOtpInputs();
  attachVerifyHandler();
})();





(function () {
  const BTN_ID = 'customer-login-button1';
  const STORAGE_KEY = 'otp';
  const OTP_LEN = 4;

  const btn = document.getElementById(BTN_ID);
  const boxes = Array.from(document.querySelectorAll('.otp-box'));
  if (!btn || boxes.length === 0) return;

  // ---- NEW: focus helper for customer[email]
  function focusEmailField() {
    const email = document.querySelector('input[name="customer[email]"]');
    if (!email) return;
    if (email.hasAttribute('disabled')) email.removeAttribute('disabled');
    // focus without jumping the page first, then scroll into view smoothly
    email.focus({ preventScroll: true });
    email.scrollIntoView({ behavior: 'smooth', block: 'center' });
    // (optional) put caret at end of existing value
    const v = email.value; email.value = ''; email.value = v;
  }

  // simple error UI
  //let errorEl = document.getElementById('otp_error');
  let errorEl = document.getElementById('otp-error');
  if (!errorEl) {
    errorEl = document.createElement('p');
    errorEl.id = 'otp_error';
    errorEl.setAttribute('role', 'alert');
    errorEl.style.cssText = 'color:#c00;margin:.35rem 0 0;font-size:.9rem;display:none;';
    
    boxes[boxes.length - 1].after(errorEl);
  }
  function setError(msg) { errorEl.textContent = msg || ''; errorEl.style.display = msg ? 'block' : 'none'; }
  function setInputsError(on) { boxes.forEach(b => b.classList.toggle('otp-error', !!on)); }

  const norm = (s) => (s || '').toString().replace(/\D/g, '').slice(0, OTP_LEN);
  function getOtpFromBoxes() {
    boxes.forEach(b => b.value = (b.value || '').replace(/\D/g, '').slice(0, 1));
    return boxes.map(b => b.value).join('');
  }

  let matchedOnce = false; // avoid re-focusing on every keypress

  function updateButtonState(showMismatchMsg = true) {
    const entered = norm(getOtpFromBoxes());
    const stored  = norm(localStorage.getItem(STORAGE_KEY));
    //check validate otp
   

    const ready = entered.length === OTP_LEN;
    // var result = validateOTP(stored, entered);
    //alert(result);
    const match = ready && stored && entered === stored;

    btn.disabled = !match;
    btn.setAttribute('aria-disabled', String(!match));

    if (!ready) { setError(''); setInputsError(false); matchedOnce = false; return; }
    if (!stored) { if (showMismatchMsg) setError('No OTP to verify. Please request a new code.'); setInputsError(true); matchedOnce = false; return; }

    if (match) {
      setError(''); setInputsError(false);
      if (!matchedOnce) { matchedOnce = true; focusEmailField(); }
    } else {
      if (showMismatchMsg) setError('Incorrect OTP. Please try again.');
      setInputsError(true);
      matchedOnce = false;
    }
  }

  boxes.forEach((box, idx) => {
    box.addEventListener('input', (e) => {
      e.target.value = (e.target.value || '').replace(/\D/g, '').slice(0, 1);
      if (e.target.value && boxes[idx + 1]) boxes[idx + 1].focus();
      updateButtonState(false);
    });
    box.addEventListener('paste', (e) => {
      const text = norm((e.clipboardData || window.clipboardData).getData('text'));
      if (!text) return;
      e.preventDefault();
      boxes.forEach((b, i) => { b.value = text[i] || ''; });
      boxes[OTP_LEN - 1]?.focus();
      updateButtonState(true);
    });
    box.addEventListener('keyup', () => {
      if (boxes.map(b => b.value).join('').length === OTP_LEN) updateButtonState(true);
    });
  });

  btn.disabled = true;
  btn.setAttribute('aria-disabled', 'true');
  updateButtonState(false);

  window.addEventListener('storage', (e) => {
    if (e.key === STORAGE_KEY) updateButtonState(true);
  });
})();


// Example usage inside your validate()/submit code:
//encryption
/**
 * Simple OTP Decryption Function for Shopify
 * 
 * Add this function to your existing Shopify JS file.
 * This function decrypts the encrypted OTP from server and compares it with user input.
 */

/**
 * Decrypts encrypted OTP data and compares with user input
 * @param {string} encryptedOtp - Base64 encoded encrypted OTP from server
 * @param {string} userInput - OTP code entered by user
 * @param {string} encryptionKey - Optional encryption key (uses default if not provided)
 * @returns {Promise<Object>} Result object with success, match, and data
 */
async function compareOTP(encryptedOtp, userInput, encryptionKey = null) {
    try {
        // Use provided key or default
        const key = encryptionKey || 'avicen_otp_encryption_key_2024_secure_12345';
        
        // Decrypt the OTP data
        const otpData = await decryptOTPData(encryptedOtp, key);
        
        if (!otpData) {
            return {
                success: false,
                match: false,
                error: 'Failed to decrypt OTP data',
                isExpired: true
            };
        }
        
        // Check if OTP is expired
        const currentTime = Math.floor(Date.now() / 1000);
        const isExpired = currentTime > otpData.expiry;
        
        if (isExpired) {
            return {
                success: false,
                match: false,
                error: 'OTP has expired',
                isExpired: true,
                otpData: otpData
            };
        }
        
        // Compare OTP codes
        const match = otpData.otp === userInput;
        
        return {
            success: true,
            match: match,
            isExpired: false,
            otpData: otpData,
            timeRemaining: otpData.expiry - currentTime
        };
        
    } catch (error) {
        return {
            success: false,
            match: false,
            error: error.message,
            isExpired: true
        };
    }
}

/**
 * Decrypts OTP data using AES-256-CBC
 * @param {string} encryptedData - Base64 encoded encrypted data
 * @param {string} keyString - Encryption key
 * @returns {Promise<Object|null>} Decrypted OTP data or null
 */
async function decryptOTPData(encryptedData, keyString) {
    try {
        console.log('Decrypting OTP data:', encryptedData.substring(0, 50) + '...');
        console.log('Data length:', encryptedData.length);
        
        // Check if this looks like plain text OTP (4-6 digits)
        if (encryptedData.length <= 6 && /^\d+$/.test(encryptedData)) {
            console.log('Detected plain text OTP, creating mock data structure');
            // This is plain text OTP, create a mock data structure
            return {
                otp: encryptedData,
                expiry: Math.floor(Date.now() / 1000) + 300, // 5 minutes from now
                timestamp: Math.floor(Date.now() / 1000)
            };
        }
        
        // Decode base64
        const binaryData = base64ToArrayBuffer(encryptedData);
        console.log('Binary data length:', binaryData.byteLength);
        
        // Check if we have enough data for IV + ciphertext
        if (binaryData.byteLength < 17) {
            throw new Error('Encrypted data too short - need at least 17 bytes (16 for IV + 1 for ciphertext)');
        }
        
        // Extract IV (first 16 bytes) and ciphertext
        const iv = binaryData.slice(0, 16);
        const ciphertext = binaryData.slice(16);
        
        console.log('IV length:', iv.byteLength);
        console.log('Ciphertext length:', ciphertext.byteLength);
        
        // Generate key from encryption key
        const key = await generateKey(keyString);
        
        // Decrypt using Web Crypto API
        const decryptedBuffer = await crypto.subtle.decrypt(
            { name: 'AES-CBC', iv: iv },
            key,
            ciphertext
        );
        
        // Convert to string and parse JSON
        const decryptedText = new TextDecoder().decode(decryptedBuffer);
        console.log('Decrypted text:', decryptedText);
        return JSON.parse(decryptedText);
        
    } catch (error) {
        console.error('OTP decryption failed:', error);
        console.error('Encrypted data length:', encryptedData.length);
        console.error('Encrypted data (first 100 chars):', encryptedData.substring(0, 100));
        return null;
    }
}

/**
 * Generate encryption key from string
 * @param {string} keyString - The encryption key string
 * @returns {Promise<CryptoKey>} Generated encryption key
 */
async function generateKey(keyString) {
    const encoder = new TextEncoder();
    const data = encoder.encode(keyString);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    return await crypto.subtle.importKey(
        'raw',
        hashBuffer,
        { name: 'AES-CBC' },
        false,
        ['decrypt']
    );
}

/**
 * Convert base64 string to ArrayBuffer
 * @param {string} base64 - Base64 encoded string
 * @returns {ArrayBuffer} Binary data
 */
function base64ToArrayBuffer(base64) {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}

/**
 * Simple function to validate OTP - just call this from your form
 * @param {string} encryptedOtp - Encrypted OTP from server response
 * @param {string} userOtp - OTP entered by user
 * @returns {Promise<boolean>} True if OTP matches and is valid, false otherwise
 */
async function validateOTP(encryptedOtp, userOtp) {
    const result = await compareOTP(encryptedOtp, userOtp);
    return result.success && result.match && !result.isExpired;
}

/**
 * Simple OTP validation that works with both encrypted and plain text OTPs
 * @param {string} serverOtp - OTP from server (encrypted or plain text)
 * @param {string} userOtp - OTP entered by user
 * @returns {Promise<boolean>} True if OTP matches, false otherwise
 */
async function validateOTPSimple(serverOtp, userOtp) {
    try {
        // Check if server OTP is plain text (4-6 digits)
        if (serverOtp.length <= 6 && /^\d+$/.test(serverOtp)) {
            console.log('Using plain text OTP validation');
            return serverOtp === userOtp;
        }
        
        // Try encrypted OTP validation
        console.log('Using encrypted OTP validation');
        return await validateOTP(serverOtp, userOtp);
        
    } catch (error) {
        console.error('OTP validation error:', error);
        return false;
    }
}

// Example usage in your Shopify form:
/*
// When user submits OTP form
async function handleOTPSubmit() {
    const encryptedOtp = document.getElementById('encrypted-otp').value; // Hidden field with encrypted OTP
    const userOtp = document.getElementById('otp-input').value; // User input field
    
    const isValid = await validateOTP(encryptedOtp, userOtp);
    
    if (isValid) {
        // OTP is correct and not expired
        console.log('OTP is valid!');
        // Proceed with your form submission
        submitForm();
    } else {
        // OTP is invalid or expired
        console.log('OTP is invalid or expired');
        showError('Invalid or expired OTP');
    }
}
*/

